import React from 'react';
import { X, CheckCircle2 } from 'lucide-react';
import { ProcessedInvoice, PaymentData } from '../../types';
import PDFViewer from '../pdf/PDFViewer';
import PaymentSidebar from './PaymentSidebar';
import PaymentStatusBadge from './PaymentStatusBadge';

interface PaymentPreviewModalProps {
  invoice: ProcessedInvoice;
  onClose: () => void;
  onDataChange: (id: string, data: PaymentData) => void;
  isValid: boolean;
}

export default function PaymentPreviewModal({
  invoice,
  onClose,
  onDataChange,
  isValid
}: PaymentPreviewModalProps) {
  const handleDataChange = (data: PaymentData) => {
    onDataChange(invoice.id, data);
  };

  const handleMarkAsPaid = () => {
    onDataChange(invoice.id, {
      ...invoice.data,
      status: 'paid'
    });
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex">
      <div className="flex-1 flex">
        {/* Main Content - PDF Preview */}
        <div className="flex-1 p-6 overflow-auto">
          <div className="max-w-4xl mx-auto">
            <div className="flex justify-between items-center mb-4">
              <PaymentStatusBadge status={invoice.data.status || 'pending'} />
              {invoice.data.status !== 'paid' && isValid && (
                <button
                  onClick={handleMarkAsPaid}
                  className="inline-flex items-center gap-2 px-4 py-2 rounded-lg text-sm font-medium bg-green-600 hover:bg-green-700 text-white transition-colors"
                >
                  <CheckCircle2 className="w-4 h-4" />
                  Mark as Paid
                </button>
              )}
            </div>
            <div className="bg-black/20 rounded-lg overflow-hidden">
              <PDFViewer file={invoice.file} />
            </div>
          </div>
        </div>

        {/* Payment Sidebar */}
        <PaymentSidebar
          data={invoice.data}
          onChange={handleDataChange}
          onClose={onClose}
          isValid={isValid}
        />
      </div>
    </div>
  );
}